import InputGroup from "react-bootstrap/InputGroup"

export default function Container({ children, marginBottom = "mb-3" }) {
  return <InputGroup className={marginBottom}>{children}</InputGroup>
}
